import type { Program } from '@/api';

export const useProgramPolicy = (model: Ref<Program | undefined>) => {
    const { company, permissions, isSuperAdmin, isStaff, authority } = useCompany();
    const getPolicy = (model: Program | undefined) => {
        const update = model?.company_id === company.value?.id && permissions.value.editPrograms;

        return {
            update,
        };
    };

    const policy = computed(() => getPolicy(model.value));

    return { policy, getPolicy };
};
